import {Component, OnDestroy, OnInit} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SharedService } from '../../../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { ExpressPayService } from '../express-pay.service';
import { FormControl, Validators, FormBuilder, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { CashOnlyDialog } from '../../../dashboard/dashboard/dashboard.component';
import { LoggerService } from 'app/logger/logger.service';
import {DataDogRumService} from '../../../datadog/DataDogRumService';

// global const define
// const MOBILE_REGEX = /^\(\d{3}\)\s\d{3}\-\d{4}$/;
const MOBILE_REGEX = /^\d{10}$/;
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'app-express-pay',
  templateUrl: './express-pay.component.html',
  styleUrls: ['./express-pay.component.css']
})
export class ExpressPayComponent implements OnInit, OnDestroy {
  // express pay validation
  servicePhoneNumberFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(MOBILE_REGEX)]);
  // variables define
  // input_tagline: string;
  email_or_mobile_phone: string = "";
  // private phone_number: string;
  is_email_mobile_phone: boolean;
  public emailOrMobileForm;
  public error_message: string = "";
  public is_error: boolean = false;
  msite_base_url: string;
  // public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(private meta: Meta, private title: Title, private fb: FormBuilder,private logger:LoggerService, private activatedRoute: ActivatedRoute, private sharedService: SharedService,
    private localStorageService: LocalStorageService, private router: Router,
	private datadog: DataDogRumService,
    private expressPayService: ExpressPayService, private dialog: MatDialog) {
    this.addUpdateMetaTags();
    this.sharedService.setHeaderTitle('default_page');
    this.msite_base_url = '' + this.localStorageService.get('msite_base_url');

    this.emailOrMobileForm = fb.group({
      emailMobilePhoneFormControl: ['', Validators.required]
    }, { validator: EmailOrMobileValidation.EmailOrMobileValidate });

    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (this.router.url.endsWith("ExpressPay") && event.url.endsWith("ExpressPay")) {
            console.log("We are moving out of Express Pay");
          }
        }
      });
      let methodName = this.constructor.name+'.verifyToken';
    if (this.localStorageService.get('token') != null && this.localStorageService.get('token') !="") {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then(res => {
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            response: res
          };
          this.logger.logInfo(JSON.stringify(logObj));
          if (res.status === 'success' && res.isTerminated === false) {
            if (res.cashOnly) {
              this.dialog.open(CashOnlyDialog);
            } else {
              this.router.navigate(['./make-payment']);
            }
          } else {
            const that = this.sharedService;
            setTimeout(function () {
              this.is_error = false;
              that.setHeaderTitle('express_pay');
            }, 10);
            // this.input_tagline = 'Enter the phone number associated with the Pogo Energy account';
            this.is_email_mobile_phone = false;
            this.localStorageService.remove('mobile_phone');
          }
        }, (error)=>{
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: error
          };
          this.logger.logError(JSON.stringify(logObj));
        }).catch((ex)=>{
          let logObj = {
            method: methodName,
            request: "token : [masked]",
            exception: ex
          };
          this.logger.logError(JSON.stringify(logObj));
        });
    } else {

      // if (this.localStorageService.get('used_email') != null && this.localStorageService.get('used_mobile_no') != "") {
      //   this.router.navigate(['./make-payment']);
      // } else if (this.localStorageService.get('used_email') != null && this.localStorageService.get('used_email') != "") {
      //   this.router.navigate(['./make-payment']);
      // } else {
        const that = this.sharedService;
        setTimeout(function () {
          this.is_error = false;
          that.setHeaderTitle('express_pay');
        }, 10);
        // this.input_tagline = 'Enter the phone number associated with the Pogo Energy account';
        this.is_email_mobile_phone = false;
        this.localStorageService.remove('mobile_phone');
        this.localStorageService.remove('account_number');
      // }
    }
  }

  addUpdateMetaTags() {
    this.title.setTitle('Recharge  | Pogo Energy');
    const titleTag = this.meta.getTag('name=title');

    if (titleTag != undefined) {
      this.meta.updateTag({ name: 'title', content: 'Recharge  | Pogo Energy' });
    } else {
      this.meta.addTag({ name: 'title', content: 'Recharge  | Pogo Energy' });
    }

    const descriptionTag = this.meta.getTag('name=description');

    if (descriptionTag != undefined) {
      this.meta.updateTag({ name: 'description', content: 'Charge up your Pogo Energy account right on your phone or with cash at thousands of convenient cash locations.' });
    } else {
      this.meta.addTag({ name: 'description', content: 'Charge up your Pogo Energy account right on your phone or with cash at thousands of convenient cash locations.' });
    }
  }

  ngOnDestroy() {
    this.title.setTitle('Pogo Energy');
    const titleTag = this.meta.getTag('name=title');

    if (titleTag != undefined) {
      this.meta.updateTag({ name: 'title', content: 'Pogo Energy' });
    }

    const descriptionTag = this.meta.getTag('name=description');

    if (descriptionTag != undefined) {
      this.meta.updateTag({ name: 'description', content: '' });
    }
  }

  ngOnInit() {
	  this.localStorageService.set('is_express_pay', false);
  }

  redirectLocationPage() {
    window.location.href = this.localStorageService.get('msite_base_url') + 'locations';
  }

  redirectSignInPage() {
    this.router.navigate(['./payment/sign-in']);
  }

  emailOrMobilePhoneValidate(express_pay: any) {
    this.is_error = false;

    if (this.email_or_mobile_phone != undefined && this.email_or_mobile_phone.trim() != "") {
      let username = this.email_or_mobile_phone;
      if (!username.includes("@")) {
        username = username.replace(/\(/g, "").replace(/\)/g, "").replace(/\./g, "").replace(/\-/g, "").replace(/\s/g, "");
      }
      if ((username.match(MOBILE_REGEX)) || username.match(EMAIL_REGEX)) {
        this.is_email_mobile_phone = true;
        if (express_pay.keyCode === 13) {
          document.getElementById('express_pay_btn').click();
        }
      } else {
        this.is_email_mobile_phone = false;
      }
    } else {
      this.is_email_mobile_phone = false;
    }
  }

  makePayment() {
    this.is_error = false;
    let username = this.email_or_mobile_phone;
    if (!username.includes("@")) {
      username = username.replace(/\(/g, "").replace(/\)/g, "").replace(/\./g, "").replace(/\-/g, "").replace(/\s/g, "");
    }
    if (username.match(EMAIL_REGEX)) {
      this.continueWithEmail();
    } else if (username.match(MOBILE_REGEX)) {
      this.continueWithMobile();
    }
  }

  continueWithMobile() {
    this.is_error = false;
    this.expressPayService.mobileNoExist({
		'mobilePhoneNumber': this.email_or_mobile_phone.replace(/\(/g, "").replace(/\)/g, "").replace(/\./g, "").replace(/\-/g, "").replace(/\s/g, ""),
		isExpressPay: true
	}).then(res => {
        if(res.isExists) {
            this.localStorageService.set('mobile_phone', this.email_or_mobile_phone.replace(/\(/g, "").replace(/\)/g, "").replace(/\./g, "").replace(/\-/g, "").replace(/\s/g, ""));
            this.localStorageService.set('account_number', res.accountNumber);
			this.datadog.addCustomContext('billingAccountNumber', res.accountNumber);
            this.localStorageService.set('cash_only', res.isCashOnly);
			this.localStorageService.set('is_express_pay', true);
            if (res.isCashOnly) {
              this.sharedService.setCashOnlyUser(true);
              this.dialog.open(CashOnlyDialog);
            } else {
              this.router.navigate(['./make-payment']);
            }

        } else {
          this.error_message = res.message;
          this.is_error = true;
        }
    });
  }

  // payment make
  continueWithEmail() {
    this.is_error = false;
    let methodName = this.constructor.name+'.continueWithEmail';
    this.expressPayService.emailExist({
		'email': this.email_or_mobile_phone,
		isExpressPay: true
	}).then(res => {
      let logObj = {
        method: methodName,
        request: 'email or phone' + this.email_or_mobile_phone,
        response: res
      };
      this.logger.logInfo(JSON.stringify(logObj));
        if (res.isExists) {
            this.localStorageService.set('email', this.email_or_mobile_phone);
            this.localStorageService.set('account_number', res.accountNumber);
			this.datadog.addCustomContext('billingAccountNumber', res.accountNumber);
            this.localStorageService.set('cash_only', res.cashOnly);
			this.localStorageService.set('is_express_pay', true);
            if (res.isCashOnly) {
              this.localStorageService.set('cash_only', res.isCashOnly);
              this.dialog.open(CashOnlyDialog);
            } else {
              this.router.navigate(['./make-payment']);
            }

        } else {
          this.error_message = res.message;
          this.is_error = true;
        }
    }, (error)=>{
      let logObj = {
        method: methodName,
        request: 'email or phone' + this.email_or_mobile_phone,
        exception: error
      };
      this.logger.logError(JSON.stringify(logObj));
    }).catch((ex)=>{
      let logObj = {
        method: methodName,
        request: 'email or phone' + this.email_or_mobile_phone,
        exception: ex
      };
      this.logger.logError(JSON.stringify(logObj));
    });
  }
}


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'express-pay-info',
  // tslint:disable-next-line:max-line-length
  template: '<div class="dialog-main"><button mat-icon-button class="dialog-close-btn" [mat-dialog-close]="true"><mat-icon>&#xE5CD;</mat-icon></button><div class="dialog-info"><p>We’re unable to complete your payment transaction at this time. Please try again later, or please chat with us or call us at 888.764.6669 to get immediate assistance.</p></div></div><div class="footer"><button mat-button class="double-block-btn" [mat-dialog-close]="true">Ok</button></div>'
})
// tslint:disable-next-line:component-class-suffix
export class ExpressPayInfo {

}

export class EmailOrMobileValidation {

  static EmailOrMobileValidate(AC: AbstractControl) {
    let username: string = AC.get('emailMobilePhoneFormControl').value; // to get value in input tag
    if (!username.includes("@")) {
      username = username.replace(/\(/g, "").replace(/\)/g, "").replace(/\./g, "").replace(/\-/g, "").replace(/\s/g, "");
    }
    if (username !== '' && !username.match(MOBILE_REGEX) && !username.match(EMAIL_REGEX)) {
      AC.get('emailMobilePhoneFormControl').setErrors({ EmailOrMobileValidate: true })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/express-pay/express-pay/express-pay.component.ts